import * as React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Layout from './Layout';
import SubLayout from './SubLayout';
import Home from './Home';
import LegacyReport from './report/LegacyReport'
import LegacyTask from './report/LegacyTask'
import LogIn from './LogIn'
import SignIn from './auth/SignIn'
import Logout from './auth/Logout'
import EmployeeMasterComponent from '../components/Employee/EmployeeMasterComponent';
import Ingress from './modules/ingress'

import { Route, Switch } from 'react-router';
import { PrivateRoute } from './PrivateRoute';

import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { NotFound } from "../presentation/NotFound/NotFound";

export default (props: { children?: React.ReactNode }, store) => (
    <React.Fragment>
        <Switch>
            <Route path='/Login' component={LogIn} />
            <Route path='/auth/signin' component={SignIn} />
            <Route path='/ingress' component={Ingress} />
            <SubLayout>
                <PrivateRoute exact path='/' component={Home} />

                <PrivateRoute path='/legacytask' component={LegacyTask} />
                <PrivateRoute path='/legacyreport' component={LegacyReport} />
                <PrivateRoute path='/employee' component={EmployeeMasterComponent} />
                <PrivateRoute path='/logout' component={Logout} />
                <PrivateRoute path='*' component={NotFound} />
            </SubLayout>
        </Switch>
    </React.Fragment>
);
